import config from "@/config";
import { router } from "@/router";
import { _get, _getNull } from "@utils/utils";
import { sessionStorage, storage } from "@utils/storage";

/**
 * 返回上个页面实例，如果没有则返回null
 * @returns {(Page.PageInstance<AnyObject, {}> & {})|null}
 */
export const getPrePage = () => {
    const pages = getCurrentPages();
    // 没有上个页面返回 null
    if (pages.length - 2 < 0) return null;
    return pages[pages.length - 2]
}

/**
 * 返回当前页面实例，如果没有则返回null
 * @returns {(Page.PageInstance<AnyObject, {}> & {})|null}
 */
export const getCurrPage = () => {
    const pages = getCurrentPages();
    return pages[pages.length - 1]
}

/**
 * 通过页面 path 获取上个页面路由信息
 * @param page
 */
export const getRouteByPath = (page) => {
    if (!page || !page.route) return null;
    let route = config.router.routes.find(n => {
        return n.path.indexOf(page.route) > -1
    });

    if (!route) return null;

    return {
        ...route,
        // #ifdef MP-WEIXIN
        query: {
            ...(page || {}).options || {}
        },
        // #endif

        // #ifdef H5
        query: {
            ..._get(page, '$page.options', {})
        },
        // #endif
    }
}

/**
 * 获取页面路由信息
 * @param type - pre：上一个页面，curr或不传默认取当前页面
 * @returns {(*&{query: *})|null}
 */
const getPageRoute = (type = '') => {
    const page = type === 'pre' ? getPrePage() : getCurrPage();
    if (!page) return null;
    return getRouteByPath(page)
}

/**
 * 获取上个页面路由信息
 * @returns {*|null}
 */
export const getPrePageRoute = () => {
    return getPageRoute('pre')
}

/**
 * 获取当前页面路由信息
 * @returns {*|null}
 */
export const getCurrPageRoute = () => {
    return getPageRoute('')
}

/**
 * 获取当前页面参数
 * @returns {*}
 */
export const getCurrPageQuery = () => {
    return _get(getPageRoute(''), 'query', {})
}

/**
 * 刷新当前页面
 */
export const refreshPage = () => {
    const res = getCurrPageRoute()
    router[_getNull(res, 'meta.tabBar') ? 'reLaunch' : 'redirectTo']({
        name: res.alias,
        query: res.query
    })
}


export const setLoginSuccessRouter = (routerInfo) => {
    // #ifdef MP-WEIXIN
    sessionStorage.set('loginRedirect', routerInfo);
    // #endif

    // #ifdef H5
    storage.set('loginRedirect', routerInfo);
    // #endif
}

export const removeLoginSuccessRouter = () => {
    // #ifdef MP-WEIXIN
    sessionStorage.remove('loginRedirect');
    // #endif

    // #ifdef H5
    storage.remove('loginRedirect');
    // #endif
}

export const getLoginSuccessRouter = () => {
    // #ifdef MP-WEIXIN
    return sessionStorage.set('loginRedirect');
    // #endif

    // #ifdef H5
    return storage.set('loginRedirect');
    // #endif
}
